export default __webpack_public_path__ + "static/media/play.f3a1f8c8.png";